<template>
  <div>
    <div class="wap1">
      <div class="wap1-content">
        <h1 class="title">{{ networkDistribution.titleOne }}</h1>
        <p>
          {{ networkDistribution.contentOne }}
        </p>
      </div>
      <div class="network_map">
        <img :src="networkDistribution.imgaeOne" style="width:100%;" alt="" />
      </div>
    </div>
    <div class="wap3-content">
      <div class="company" v-for="v,i in networkList" :key="i">
        <h3 >{{ v[`${currentLang.prefix}title`] }}</h3>
        <p v-html="$convertPxToRem(v[`${currentLang.prefix}content`])"></p>
      </div>    
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getArticleList } from "@/utils/http.js";


export default {
  name: 'Network',
  
  data(){
    return{
      networkList: []
    }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    networkDistribution() {
      return this.currentLang.config.aboutPage.networkDistribution
    }
  },

  created() {
    this.fetchAddressList()
  },

  methods: {
    fetchAddressList() {
      const query = {
        cate_id: 4,
        page: 1,
        limit: 1000,
      }
      getArticleList(query).then((res) => {
        if (res.code === 1) {
          this.networkList = res.data.list;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: center;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      margin-top: 40px;
      margin-bottom: 60px;
      line-height: 1.8;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.network_map {
  width: 1200px;
  height: auto;
  margin: 0 auto 0;
}
.wap3-content {
  width: 1200px;
  margin: 0 auto 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;
  flex-wrap: wrap;
  .company {
    width: 30%;
    margin-bottom: 40px;
    h3 {
      color: #003c7a;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 16px;
    }
    p{
        color: #777!important;
        font-size: 16px;
        line-height: 28px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/Network.vue